import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'

export function getAccountingList(params) {
  return request({
    url: '/GetAccountingList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 18000001,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        Type: params.Type,
        Status: params.Status,
        ApplyName: params.ApplyName,
        KeyWord: params.KeyWord,
        StartDate: params.StartDate,
        EndDate: params.EndDate
      }
    }
  })
}

export function addCashRequirement(params) {
  return request({
    url: '/AddCashRequirement',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 18000002,
      MessageID: btcguid(),
      Data: {
        ApplyName: params.ApplyName,
        ApplyAmount: params.ApplyAmount,
        ApplyExplain: params.ApplyExplain,
        LastTime: params.LastTime,
        File: params.File
      }
    }
  })
}

export function addReimbursement(params) {
  return request({
    url: '/AddReimbursement',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 18000003,
      MessageID: btcguid(),
      Data: {
        BillNum: params.BillNum,
        ApplyName: params.ApplyName,
        ApplyAmount: params.ApplyAmount,
        ApplyExplain: params.ApplyExplain,
        AccountingDetails: params.AccountingDetails,
        AccountingPictures: params.AccountingPictures
      }
    }
  })
}

export function uploadCashRequirement(params) {
  const formData = new FormData()
  formData.append('MessageType', 18000004)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  formData.append('UserID', params.UserID)
  return request({
    url: '/UploadCashRequirement',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function updateCashRequirement(params) {
  return request({
    url: '/UpdateCashRequirement',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 18000005,
      MessageID: btcguid(),
      Data: {
        AccountingID: params.AccountingID,
        HandlerName: params.HandlerName,
        RejectReason: params.RejectReason,
        Status: params.Status,
        File: params.File,
        ApplyAmount: params.ApplyAmount,
        ApplyExplain: params.ApplyExplain,
        LastTime: params.LastTime,
        Flag: params.Flag
      }
    }
  })
}

export function uploadReimbursement(params) {
  const formData = new FormData()
  formData.append('MessageType', 18000006)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  formData.append('UserID', params.UserID)
  // formData.append('AccountingID', params.AccountingID)
  return request({
    url: '/UploadReimbursement',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function getReimbursement(params) {
  return request({
    url: '/GetReimbursement',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 18000007,
      MessageID: btcguid(),
      Data: {
        AccountingID: params.AccountingID
      }
    }
  })
}

export function approvalReimbursement(params) {
  return request({
    url: '/ApprovalReimbursement',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 18000008,
      MessageID: btcguid(),
      Data: {
        HandlerName: params.HandlerName,
        AccountingID: params.AccountingID,
        ApprovalType: params.ApprovalType,
        RejectReason: params.RejectReason,
        AccountingPictures: params.AccountingPictures
      }
    }
  })
}

export function updateReimbursement(params) {
  return request({
    url: '/UpdateReimbursement',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 18000009,
      MessageID: btcguid(),
      Data: {
        BillNum: params.BillNum,
        ApplyName: params.ApplyName,
        ApplyAmount: params.ApplyAmount,
        ApplyExplain: params.ApplyExplain,
        AccountingID: params.AccountingID,
        RemoveDetails: params.RemoveDetails,
        RemovePictures: params.RemovePictures,
        AccountingDetails: params.AccountingDetails,
        AccountingPictures: params.AccountingPictures
      }
    }
  })
}

export function emptyAccounting(params) {
  return request({
    url: '/EmptyAccounting',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 18000010,
      MessageID: btcguid(),
      Data: {
        ApplyName: params.ApplyName,
        Type: params.Type
      }
    }
  })
}
export function deleteAccounting(params) {
  return request({
    url: '/DeleteAccounting',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 18000011,
      MessageID: btcguid(),
      Data: {
        AccountingID: params.AccountingID
      }
    }
  })
}

export function getRunningAccountList(params) {
  return request({
    url: '/GetRunningAccountList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 18000012,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        Type: params.Type,
        Status: params.Status,
        KeyWord: params.KeyWord,
        StartDate: params.StartDate,
        EndDate: params.EndDate
      }
    }
  })
}

export function getAdminUsers(params) {
  return request({
    url: '/GetAdminUsers',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 18000013,
      MessageID: btcguid(),
      Data: {}
    }
  })
}

export function addRunningAccount(params) {
  return request({
    url: '/AddRunningAccount',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 18000014,
      MessageID: btcguid(),
      Data: {
        DeclareName: params.DeclareName,
        Amount: params.Amount,
        CreateTime: params.CreateTime,
        Note: params.Note,
        Type: params.Type
      }
    }
  })
}

export function updateRunningAccount(params) {
  return request({
    url: '/UpdateRunningAccount',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 18000015,
      MessageID: btcguid(),
      Data: {
        RunningAccountID: params.RunningAccountID,
        DeclareName: params.DeclareName,
        Amount: params.Amount,
        CreateTime: params.CreateTime,
        Note: params.Note,
        Type: params.Type,
        Status: params.Status
      }
    }
  })
}

export function getRedDot(params) {
  return request({
    url: '/GetRedDot',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 18000016,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID
      }
    }
  })
}

export function emptyRedDot(params) {
  return request({
    url: '/EmptyRedDot',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 18000017,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID,
        Type: params.Type
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/accounting.js